import React, { useEffect, useState } from 'react'
import { sortDisplayOrder } from '../../../../services/util';
import { getTickets } from '../../../../revampCRUD/ticketsNforms.crud';
import customToast from '../../../../components/common/basic/Toast';
import Select from 'react-select';
import { dashboardColors, theme } from '../../../../themes/Theme';

const customStyles = {
    option: (styles, { isFocused, isSelected }) => ({
        ...styles,
        background: isSelected ? dashboardColors[theme].primary : isFocused ? "#e2e8f0" : "white",
        margin: "0px",
        color: isSelected ? "white" : isFocused ? "#1a202c" : "#4a5568",
        zIndex: 10,
        overflowX: "hidden",
        wordBreak: "break-word",
        cursor: "pointer",
    }),
    menu: (provided) => ({
        ...provided,
        marginTop: "2px",
        overflow: "hidden",
        zIndex: 10,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    dropdownIndicator: (base) => ({
        ...base,
        color: dashboardColors[theme].primaryTextColor,
        padding: "5px 8px",
        zIndex: 10,
        "&:hover": {
            color: dashboardColors[theme].primaryTextColor,
        },
    }),
    control: (base, state) => ({
        ...base,
        border: state.isFocused ? `1px solid ${dashboardColors[theme].primary}` : "1px solid #cdd4db",
        boxShadow: "none",
        borderRadius: "2px",
        minHeight: "36px",
        maxHeight: "2.5em",
    }),
};
const TicketsDropdown = ({ eventId, setSelectedTicket, selectedTicket,ticketsData,setTicketsData }) => {
    const [loading, setLoading] = useState(true);
    const [selectedOption, setSelectedOption] = useState(null);
    const [filter, setFilter] = useState({ key: "", coupons: [], tickets: [] });
    const getTicketAPI = async () => {
        const data = await getTickets(eventId);
        const uncategorised = sortDisplayOrder(data.data.uncategorized, "ticket_order");
        const categories = sortDisplayOrder(data.data.categorized, "category_order");
        const categorized = categories.map(category => {
            category.tickets = sortDisplayOrder(category.tickets, "ticket_order");
            return category;
        });
        setFilter({
            ...filter,
            tickets: uncategorised,
            categorizedTickets: categorized
        });
        return data;
    };

    const getListOfTickets = async () => {
        setLoading(true);
        try {
            const response = await getTicketAPI();
            const uncategorized = response?.data?.uncategorized || [];
            const categorized = response?.data?.categorized || [];

            const categorizedTickets = categorized?.flatMap(category => category?.tickets || []);

            const sortedTickets = sortDisplayOrder([...uncategorized, ...categorizedTickets], 'ticket_order');
            const formattedOptions = sortedTickets?.map(ticket => ({
                value: ticket?.ticket_id,
                label: ticket?.ticket_name,
                isHidden: ticket?.hidden_ticket
            }));
            setTicketsData(formattedOptions);
        } catch (error) {
            customToast.error(error.message || ErrMessages.DEFAULT_ERROR_MESSAGE);
        } finally {
            setLoading(false);
        }
    };
    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption);
        setSelectedTicket(selectedOption);
    };
    useEffect(() => {
        getListOfTickets();
    }, []);
    return (
        <div>
            <Select
                value={selectedOption}
                onChange={handleChange}
                options={ticketsData}
                placeholder={`${loading ? "Loading tickets" : "Select ticket name"}`}
                styles={customStyles}
                isDisabled={loading || ticketsData.length === 0}
                // menuPortalTarget={document.body}
                // menuPlacement="auto"
                isSearchable
            />
        </div>
    )
}

export default TicketsDropdown

